<template>
  <div id="body">
    <div id="app">
        <gdpr-prompt></gdpr-prompt>
        <div class="nav-header">
            <div class="level nav-level is-mobile">
                <div class="level-left">
                    <md-button class="md-icon-button md-dense" @click="showNavigation = !showNavigation">
                        <md-icon v-if="showNavigation === false">menu</md-icon>
                        <md-icon v-else-if="showNavigation === true">close</md-icon>
                    </md-button>
                </div>
                <div class="level-right">
                    <img src="./assets/flapp_match_logo.svg" id="logo"/>
                </div>
            </div>
        </div>
        <div id="router-view">
            <router-view></router-view>
        </div>
        <drawer :show-navigation.sync="showNavigation"></drawer>
    </div>
  </div>
</template>

<style lang="scss">
  @import "~bulma/sass/utilities/_all";
  @import url('https://fonts.googleapis.com/css?family=Work+Sans:400,500&display=swap');

  $primary: #00a86c;
  $primary-invert: findColorInvert($primary);
  $messenger: #0078FF;
  $messenger-invert: findColorInvert($messenger);
  $facebook: #4268B0;
  $facebook-invert: findColorInvert($facebook);

  $colors: (
          "white": ($white, $black),
          "black": ($black, $white),
          "light": ($light, $light-invert),
          "dark": ($dark, $dark-invert),
          "primary": ($primary, $primary-invert),
          "info": ($info, $info-invert),
          "success": ($success, $success-invert),
          "warning": ($warning, $warning-invert),
          "danger": ($danger, $danger-invert),
          "messenger": ($messenger, $messenger-invert),
          "facebook": ($facebook, $facebook-invert)
  );

  $link: $primary;
  $link-invert: $primary-invert;
  $link-focus-border: $primary;

  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  @import "~vue-material/dist/theme/engine";
  @include md-register-theme("bottom-bar-default", (
          primary: #00a86b,
          accent: #212121
  ));
  @include md-register-theme("default", (
          primary: #00a86b,
          accent: #ffffff,
          text-primary-on-primary: #ffffff
  ));
  @import "~vue-material/dist/theme/all";

  #body {
    min-height: -webkit-fill-available
  }

  #app {
    font-family: 'Work Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow-x: hidden;
    width: 100%;
  }

  #router-view {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: calc((var(--vh, 1vh) * 100) - 48px);
      overflow: scroll;
  }

  .nav-header {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      align-content: center;
      z-index: 99;
      height: 48px;
      background-color: rgb(240,240,240);
  }

  .nav-header::before {
      content: "";
      position: absolute;
      background-color: transparent;
      bottom: -42px;
      left: 0;
      height: 42px;
      width: 100vw;
      border-top-left-radius: 21px;
      border-top-right-radius: 21px;
      box-shadow: rgba(0,0,0,0.28) 0 -8px 12px -8px, rgb(240,240,240) 0 -25px 0px 0px,;
  }

    .nav-level {
        position: absolute;
        width: 100%;
        z-index: 98;
        padding: 8px 6px;
    }

    #logo {
        height: 24px;
        margin-right: 4px;
    }
</style>

<script>
    import Home from "./views/Home";
    import Borrow from "./views/Borrow";
    import 'vue-material/dist/vue-material.min.css';
    import 'vue-material/dist/theme/default.css';
    import Drawer from "./components/drawer";
    import bus from './bus.js'
    import GdprPrompt from "./components/gdpr-prompt";

    export default {
        components: {GdprPrompt, Drawer, Borrow, Home},
        data: () => ({
            theme: 'default',
            showNavigation: false
        }),
        metaInfo: {
            title: 'Where Borrowers and Lenders Meet',
            titleTemplate: '%s | Flapp Match'
        },
        mounted() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            bus.$on('closeDrawer', (p) => {
                this.showNavigation = false
            });
        }
    }
</script>
